import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'
import { RemoteControl } from './remote_control'

export async function remoteEventDriven (app) {
  const dispatcher = _.extend({}, Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => {
    dispatcher.listenTo(state.appStates.slideware, 'change:page', (slidewareState, pageValue, options) => {
      if (pageValue !== 'remote_event_driven') {
        return
      }

      const model = new RemoteControl({ user: state.get('user') })
      model.start()
    })
  })
}
